export default __webpack_public_path__ + "static/media/1267.3c1f057a.jpg";